module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('strong', [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/006_Author_Preface#fm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Abbreviations#fm-2"
    }
  }, [_vm._v("Principal Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01a#pt-1"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01a#sec2-1"
    }
  }, [_vm._v("I. Jeremiah among the Prophets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01a#sec2-2"
    }
  }, [_vm._v("II. Jeremiah in His Historical Setting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01a#sec2-3"
    }
  }, [_vm._v("III. The Book of Jeremiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01a#sec2-4"
    }
  }, [_vm._v("IV. Some Important Issues for Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec5"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01a#sec2-5"
    }
  }, [_vm._v("V. The Life of Jeremiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec6"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. The Message of Jeremiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec7"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII. The Text")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec8"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII. Poetic Forms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec9"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX. Analysis of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Part01b#sec2-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X. Select Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEXT AND COMMENTARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter00#ch-0",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superscription (1:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter01#ch-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. The Call of Jeremiah and the Two Visions (1:4–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter02a#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. The Divine Judgment on Judah and Jerusalem (2:1–25:38)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Jeremiah’s Controversy with False Prophets (26:1–29:32)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap4"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. The Book of Consolation (30:1–33:26)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap5"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. Incidents from the Days of Jehoiakim and Zedekiah (34:1–39:18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap6"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. Jeremiah’s Experiences after the Fall of Jerusalem (40:1–45:5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap7"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII. Oracles against the Nations (46:1–51:64)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap8"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII. Appendix: The Fall of Jerusalem (52:1–34)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Map#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAPS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-204ade19","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Contents.vue
// module id = 75
// module chunks = 0